import { Component, h } from 'preact';
import { Localizer } from 'preact-i18n';
import { FinText } from '../../../../i18n';
import FlagIcon from '../../../../assets/FlagIcon/FlagIcon';
import * as appStyles from '../../../../assets/global.scss';
import { Properties, WidgetTab } from '../../../../common';
import { Column, Row } from '../../../../common/Layout/Layout';
import { WithStyles, withStyles } from '../../../../style';
import { stopPropagation } from '../../../../utils';
import { BookingState, connectStore } from '../../../../store';
import { LocationCode } from '../LocationCode/LocationCode';

export interface LocationItem {
  id: string;
  title: string;
  locationCode?: string;
  subtitle: string;
  countryCode: string;
  type?: 'city' | 'airport';
}

interface StoreProps {
  enableCompactWidget: boolean;
  onAmTab: boolean;
}

export interface LocationResultProps extends Properties {
  locationItem: LocationItem;
  active: boolean;
  onSelection: (location: LocationItem) => any;
  rowClass?: string;
  ariaLabel?: string;
}

type EffectiveProps = LocationResultProps & WithStyles & StoreProps;

const mapStateToProps = ({ enableCompactWidget, currentTab }: BookingState): StoreProps => ({
  enableCompactWidget,
  onAmTab: currentTab === WidgetTab.AM,
});

@connectStore({ mapStateToProps })
@withStyles(appStyles)
export default class LocationResult extends Component<LocationResultProps> {
  selectLocation = (e: Event): void => {
    stopPropagation(e);
    const { onSelection, locationItem } = this.props;
    onSelection(locationItem);
  };

  render({
    tx,
    locationItem: { title, locationCode, subtitle, countryCode, type },
    active,
    rowClass,
    enableCompactWidget,
    onAmTab,
    ...attr
  }: EffectiveProps): h.JSX.Element {
    return (
      <Localizer>
        <li
          class={tx(this.props.class, 'cursor-pointer', 'ps-large-x', {
            'nordic-blue-50-bg nordic-blue-50-border': active,
          })}
          role="option"
          aria-selected={active}
          aria-label={
            <FinText
              id={`locationModal.aria.${type}`}
              fields={{
                country: subtitle,
                title,
                locationCode,
                type,
              }}
            />
          }
          onClick={this.selectLocation}
          id={attr.id}
        >
          <Row class={tx(rowClass, 'ps-medium-y', { 'transparent-border': active })} grow={false}>
            <Column>
              <div class="font-body-1 capitalize location-title">
                {title}
                {!onAmTab &&
                  (locationCode ? (
                    <LocationCode type={type} locationCode={locationCode} enableCompactWidget={enableCompactWidget} />
                  ) : (
                    `(${title})`
                  ))}
              </div>
              <div class={tx('font-body-1 ps-xxsmall-y nordic-blue-900-text')}>
                <FlagIcon countryCode={countryCode} />
                {subtitle}
              </div>
            </Column>
          </Row>
        </li>
      </Localizer>
    );
  }
}
